"use client"
/* */
const locales = {"de-DE": {  "copyButton.copy": `Kopieren`,
},"en-US": {  "copyButton.copy": `Copy`,
}};

export { locales as default };
//# sourceMappingURL=_.locale.json@51592c7dce2c58889664b6822f25f6d1.mjs.map
